<template>
    <div v-if="$mq != 'sm'" class="s-grid__wrapper">
        <div class="s-grid">
            <div class="s-grid__container">
                <div class="s-grid__inner">
                    <div class="s-grid__bottom"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'GridPattern'
    }
</script>

<style lang="scss" scoped>
    @import "../styles/imports";

    .s-grid__wrapper{
        overflow:hidden;
        min-height:100vh;
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        opacity:1;
        pointer-events:none;
        &::after{
            position:absolute;
            right:0;
            top:calc(100vw * 0.6 * 0.33333 * 0.5625 * 3);
            height:calc(100vw * 0.6 * 0.33333 * 0.5625);
            width:20%;
            content:'';
            background:url('../assets/dots.png') bottom left repeat;
        }
    }
    .s-grid{
        height:100%;
        width:100%;
        position:absolute;
        top:0;
        left:0;
        &::before, &::after{
            position:absolute;
            top:0;
            left:40%;
            width:1px;
            height:100%;
            content:'';
            background:rgba(255,255,255,0.2);
        }
        &::after{
            left:60%;
        }
    }
    .s-grid__container{
        width:60%;
        padding-top:0;
        position:relative;
        margin:0 auto;
        height:auto;
        min-height:100vh;
        height:100%;
        display:flex;
        border:solid 1px rgba(255,255,255,0.2);;
        border-top:none;
        border-bottom:none;
        &::before, &::after{
            position:absolute;
            top:calc(100vw * 0.6 * 0.33333 * 0.5625);
            left:-999px;
            height:1px;
            width:99999px;
            content:'';
            background:rgba(255,255,255,0.2);
        }
    }
    .s-grid__inner{
        width:100%;
        height:0;
        margin-top:calc(100vw * 0.6 * 0.33333 * 0.5625);
        padding-bottom:56.25%;
        position:relative;
        &::before{
            position:absolute;
            top:33.333%;
            left:-999px;
            height:calc(100vw * 0.6 * 0.33333 * 0.5625);
            width:99999px;
            content:'';
            border:solid 1px rgba(255,255,255,0.2);;
            border-left:none;
            border-right:none;
        }
        &::after{
            position:absolute;
            width:999px;
            height:calc(100vw * 0.6 * 0.33333 * 0.5625);
            left:0;
            top:0;
            background:url('../assets/dots.png') bottom right repeat;
            content:'';
            @include transform(translateX(-100%));
        }
    }
    .s-grid__bottom{
        position:absolute;
        bottom:0;
        left:0;
        width:100%;
        &::before, &::after{
            position:absolute;
            bottom:0;
            left:33.333%;
            height:1px;
            width:99999px;
            content:'';
            background:rgba(255,255,255,0.2);;
        }
        &::after{
            left: auto;
            right:100%;
        }
    }
</style>